var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header_wrap" }, [
      _c(
        "div",
        { staticStyle: { width: "60%" } },
        [
          _c(
            "el-steps",
            {
              staticStyle: { width: "100%" },
              attrs: { "align-center": "", active: 4 }
            },
            [
              _c("el-step", {
                attrs: { title: _vm.$t("i18n_ocean_freight_information") }
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: _vm.$t("i18n_Value_added_service") }
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: _vm.$t("i18n_shipping_information") }
              }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: _vm.$t("i18n_confirm_order") } }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: _vm.$t("i18n_order_completed") }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "count_center" }, [
      _c("div", { staticClass: "centerCoutn" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              "text-align": "center",
              "margin-top": "82px"
            }
          },
          [
            _c("i", {
              staticClass:
                "el-icon-success animate__animated animate__bounceInDown",
              staticStyle: { "font-size": "55px", color: "#00c300" }
            }),
            _vm._v(" "),
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "20px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#333333",
                  "margin-top": "27px"
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("i18n_order_completed")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "14px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#999999",
                  "margin-top": "8px"
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("i18n_waiting_shipment_to_warehoused")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "countText" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("i18n_Tracking_number")) +
                    "：" +
                    _vm._s(_vm.innos)
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("i18n_Warehouse_Code")) +
                    "："
                ),
                _c("span", [_vm._v(_vm._s(_vm.toFABck.namec))]),
                _vm._v(" "),
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.toFABck.tel))
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("i18n_recevier_address")) +
                    "：" +
                    _vm._s(_vm.toFABck.address)
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btnWrap",
            staticStyle: { width: "100%", "margin-top": "44px" }
          },
          [
            _c(
              "div",
              { staticClass: "LR_center", staticStyle: { width: "398px" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "btn1",
                    on: {
                      click: function($event) {
                        return _vm.pathBilltab()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_track_order")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn2",
                    staticStyle: { margin: "0 10px" },
                    on: {
                      click: function($event) {
                        return _vm.nextSetbill()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("i18n_continue_to_order")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { height: "30px", margin: "3px 0" },
                    attrs: { type: "warning", size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.downLoadLabel()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_download_labels")))]
                )
              ],
              1
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-232a8fc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-232a8fc4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FBAorder/FbaorderSuccess.vue
// module id = null
// module chunks = 